import { StateSchema } from 'app/config/storeConfig/types';
import { UserPermissions } from 'entities/User';

export const getSelectedPermissions = (state: StateSchema): UserPermissions[] => state.createUserModal.selectedPermissions;
